import React, { FC } from 'react';

import Loader from '../Loaders/Table';
import Placeholder from '../Placeholders/Table';
import { Container, Header, Row, Caption } from './styles';
import { Props } from './types';

const GenericTable: FC<Props> = ({ isLoading, rows }) => {
  if (isLoading) {
    return (
      <Container>
        <Header>
          <Caption>Created At</Caption>
          <Caption>Start Date</Caption>
          <Caption>End Date</Caption>
          <Caption>Download</Caption>
          <span />
        </Header>
        <Loader opacity={1} />
        <Loader opacity={0.8} />
        <Loader opacity={0.6} />
        <Loader opacity={0.4} />
      </Container>
    );
  }

  if (rows.length === 0) {
    return <Placeholder noIcon text="No reports yet" />;
  }

  return (
    <Container>
      <Header>
        <Caption>Created At</Caption>
        <Caption>Start Date</Caption>
        <Caption>End Date</Caption>
        <Caption>Download</Caption>
        <span />
      </Header>
      {rows.map((report) => (
        <Row key={report.created} row={report} />
      ))}
    </Container>
  );
};

export default GenericTable;
